// extracted by mini-css-extract-plugin
export default {"myDrinksList":"MyDrinksList_myDrinksList__JMreb","myDrinkListWrapper":"MyDrinksList_myDrinkListWrapper__9cPm4"};